import type { CompanyFilters } from "../types";

/**
 * Safe JSON parse helper for persisted filters.
 * Returns undefined for empty/invalid JSON.
 */
export function safeParseFilters(
  json: string | undefined
): CompanyFilters | undefined {
  if (!json || json.trim() === "" || json.trim() === "{}") return undefined;
  try {
    const parsed = JSON.parse(json) as CompanyFilters;
    if (
      parsed &&
      typeof parsed === "object" &&
      Object.keys(parsed).length === 0
    ) {
      return undefined;
    }
    return parsed;
  } catch (err) {
    console.error("Failed to parse CompanyFilters JSON:", err);
    return undefined;
  }
}
